import { mapStoresResult } from "../../hooks/api/adapters/hooks/api/adapters/mapStoresResult.js";
const mapAvailableFiltersToResults = (availableFilters, filteredResults, shouldFilterServicesNotAvailableAppointmentsAtStore) => {
  const updatedFilters = availableFilters?.filters.map((filter) => {
    const matchingFilterInResults = filteredResults?.filters.find((f) => f.name === filter.name);
    return {
      ...filter,
      options: filter.options.map((option) => {
        const matchingOptionInResults = matchingFilterInResults?.options.find(
          (o) => o.name === option.name
        );
        return {
          ...option,
          count: matchingOptionInResults ? matchingOptionInResults.count : 0
        };
      })
    };
  });
  return {
    results: mapStoresResult(
      filteredResults?.results,
      shouldFilterServicesNotAvailableAppointmentsAtStore
    ),
    filters: updatedFilters
  };
};
export {
  mapAvailableFiltersToResults
};
//# sourceMappingURL=map-available-filters-to-results.js.map
